import type { FC, MouseEventHandler } from 'react';
import { memo } from 'react';
import { Picture } from '@ui';

import type { Badge as BadgeT } from '@utils/prepareBadges';
import clsx from 'clsx';
import './index.scss';

interface BadgeProps extends BadgeT {
  displayNone?: boolean;
  backgroundColor?: string;
  textColor?: string;
  tooltipText?: string | null;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const Badge: FC<BadgeProps> = ({
  icon,
  displayNone,
  order,
  backgroundColor,
  textColor = '#363636',
  link,
  title,
  tooltipText,
  onClick
}) => {
  if (!title) return null;
  return (
    <div
      onClick={onClick}
      className={clsx(
        `badge`,
        !!link && `badge--link`,
        !!displayNone && 'badge--none'
      )}
      style={{
        backgroundColor,
        color: textColor,
        order
      }}
    >
      {icon && <Picture icon={icon} width='12' height='12' alt={title} />}
      {title}
      {tooltipText && link && (
        <div className='badge__tooltip'>{tooltipText}</div>
      )}
    </div>
  );
};
export default memo(Badge);
